<template>
    <Step :activeStep="2" :actions="actions">
        <template v-slot:main>
            <div class="club-step__review">
                <p class="club-step__review-title">
                    Here's what you'll recieve
                </p>
                <div class="club-step__wine-selection__list">
                    <WineCard
                        v-for="item in wineList"
                        :key="`wine-${item.ID}`"
                        :id="item.ID"
                        :wine="item.Wine"
                        :quantity="item.Quantity"
                    />
                </div>
                <div class="club-step__review-summary">
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            My Subscription
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <div class="club-step__membership-unit">
                                <p class="club-step__membership-amount">
                                    {{ getMemberTier.AnnuallyBottles / 4 }}
                                </p>
                                <p class="club-step__membership-amount-text">
                                    Bottles/
                                    <br />quarter
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            My Wines
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p
                                class="club-step__wine-selection-title"
                                v-if="getActiveCatalog"
                            >
                                {{ getActiveCatalog.Title }}
                            </p>
                            <p class="club-step__wine-selection-title" v-else>
                                Custom Selection
                            </p>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            Delivered to
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p v-if="getShippingAddress === null || getShippingAddress === undefined">
                                You have not set your shipping address.
                                <br />
                                Update your details and fill in your address.
                            </p>
                            <div
                                v-else
                                class="club-step__review-summary-item-address"
                            >
                                <p>
                                    {{ getShippingAddress.FirstName }}
                                    {{ getShippingAddress.Surname }}
                                </p>
                                <p>{{ getShippingAddress.Address }}</p>
                                <p>{{ getShippingAddress.City }}</p>
                                <p>
                                    {{ getShippingAddress.State }}
                                    {{ getShippingAddress.PostalCode }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <BillingMessage v-if="getSavedCardID === 0"/>
            </div>
        </template>
    </Step>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Step from "./layouts/Step.vue";
import WineCard from "./components/WineCard.vue";
import BillingMessage from "./components/BillingMessage.vue";
export default {
    name: "Step3",
    components: {
        Step,
        WineCard,
        BillingMessage,
    },
    mounted() {
        // this.getMemberData()

        const catalog = this.getActiveCatalog;
        if (catalog === undefined || catalog === null) {
            console.warn("No catlog this is a custom set of wines");
        }
    },
    data() {
        return {
            actions: [
                {
                    title: "Change wine selection",
                    className: "btn-outline",
                    method: this.changeSelection,
                },
                {
                    title: "Update account details",
                    className: "btn-secondary",
                    method: this.goToUpdateDetails,
                },
                {
                    title: "Update credit card",
                    className: "btn-primary",
                    method: this.goToUpdateBilling,
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            "getShipmentWines",
            "getShippingAddress",
            "getActiveCatalog",
            "getMemberTier",
            "getShippingAddressID",
            "getSavedCardID",
        ]),
        groupedShipmentWines() {
            const w = this.getUniqueWinesWithQuantity(this.getShipmentWines);
            // console.log(w);
            return w;
        },
        wineList() {
            if (this.getActiveCatalog) {
                return this.getActiveCatalog.WineItems;
            } else {
                return this.groupedShipmentWines;
            }
        },
    },
    methods: {
        ...mapActions([
            "goToUpdateDetails",
            "goToUpdateBilling",
            "setConfigStep",
            "getMemberData",
        ]),
        getUniqueWinesWithQuantity(arr) {
            return Object.values(
                arr.reduce((acc, obj) => {
                    const { ID } = obj;

                    if (ID) {
                        // If the object with the same ID is already in the accumulator, increase the quantity
                        if (acc[ID]) {
                            acc[ID].Quantity += 1;
                        } else {
                            // Otherwise, add the object to the accumulator with Quantity initialized to 1
                            acc[ID] = { ID, Quantity: 1, Wine: obj };
                        }
                    }

                    return acc;
                }, {}),
            );
        },
        changeSelection() {
            this.setConfigStep(0);
        },
    },
};
</script>
